import React from 'react';
import { useHistory } from 'react-router-dom';
import { isNativeApp } from '../../util/platformDetection';

const TermsMobile = () => {
  const history = useHistory();

  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      backgroundColor: '#000',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      paddingTop: 'env(safe-area-inset-top)'
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: '#1a1a1a',
        borderBottom: '1px solid #333',
        padding: '15px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <h2 style={{
          color: 'gold',
          margin: 0,
          fontSize: '24px',
          fontWeight: 'bold'
        }}>
          Terms & Conditions
        </h2>
        <button
          onClick={() => history.goBack()}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: '#888',
            fontSize: '28px',
            cursor: 'pointer',
            padding: '5px'
          }}
        >
          ✕
        </button>
      </div>

      {/* Content */}
      <div style={{
        flex: 1,
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        padding: '20px',
        paddingBottom: 'calc(env(safe-area-inset-bottom) + 20px)'
      }}>
        <div style={{ color: '#ccc', lineHeight: '1.6', fontSize: '16px' }}>
          <p style={{ textAlign: 'center', color: '#888', fontSize: '14px', marginBottom: '30px' }}>
            Last updated: July 9th, 2025
          </p>
          
          <p style={{ marginBottom: '20px' }}>
            These Terms and Conditions ("Terms") govern your access to and use of ChessThread.com ("ChessThread," "we," "our," or "us"), a social media platform dedicated to sharing and interacting with chess content. By accessing or using the platform, you agree to be bound by these Terms. If you do not agree, do not use the service.
          </p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            1. Acceptance of Terms
          </h3>
          <p>By using ChessThread.com, you agree to comply with and be bound by these Terms. You may be required to affirm your consent during account creation. Continued use of the platform constitutes ongoing acceptance.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            2. User Responsibilities
          </h3>
          <p><strong>You may:</strong></p>
          <ul style={{ paddingLeft: '20px', marginBottom: '15px' }}>
            <li>Create an account and publish chess-related content (e.g., games, comments, moves, discussions, etc.), for other users to view and engage with</li>
            <li>View and interact with other users' content</li>
            <li>Participate in public profiles, notifications, and discussion threads</li>
            <li>Report abuse, inappropriate content, or violations</li>
          </ul>

          <p><strong>You must:</strong></p>
          <ul style={{ paddingLeft: '20px', marginBottom: '15px' }}>
            <li>Use the platform only for chess-related purposes</li>
            <li>Maintain a respectful, harassment-free environment</li>
            <li>Follow topic relevance (chess only discussion)</li>
            <li>Be kind</li>
          </ul>

          <p><strong>You may not:</strong></p>
          <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
            <li>Harass, threaten, spam, impersonate, or exploit others</li>
            <li>Post unrelated, offensive, illegal, or malicious content</li>
            <li>Use bots or attempt to scrape website data</li>
          </ul>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            3. Account Registration and Security
          </h3>
          <p>You must provide accurate information when creating an account. You are responsible for maintaining the security of your login credentials.</p>
          <p>If you upgrade to a premium account in the future, payments will be handled via Stripe. We do not store your credit card information. Payment processing is handled securely through Stripe, and we only retain the necessary identifiers (e.g., customer ID) required for subscription verification.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            4. Acceptable Use Policy
          </h3>
          <p>You may only use ChessThread for respectful chess-related interaction. Any use intended to disrupt, exploit, or divert the platform from its purpose will result in suspension or removal.</p>
          <p><strong>Unacceptable behaviour includes but is not limited to:</strong></p>
          <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
            <li>Off-topic, sexualized, or political content</li>
            <li>Hate speech, threats, or targeted abuse</li>
            <li>Explicit language or imagery</li>
            <li>Content that infringes intellectual property rights</li>
          </ul>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            5. Community Moderation
          </h3>
          <p>Users may report content or behaviour that violates any of these Terms. Reported content will be reviewed, but not all reports will result in removal. Final moderation authority rests with ChessThread.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            6. Termination of Accounts
          </h3>
          <p>We reserve the right to suspend or delete any account, content, or activity that:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '15px' }}>
            <li>Violates these Terms</li>
            <li>Undermines the chess-focused nature of the platform</li>
            <li>Disrupts user experience or platform stability</li>
          </ul>
          <p>We may take action without prior notice and at our sole discretion.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            7. Disclaimers and Limitation of Liability
          </h3>
          <p>ChessThread is provided "as is" with no warranties, express or implied. We do not guarantee uptime, availability, or the accuracy of user-submitted content.</p>
          <p><strong>We are not liable for:</strong></p>
          <ul style={{ paddingLeft: '20px', marginBottom: '15px' }}>
            <li>Loss of data or content</li>
            <li>User behavior or harmful content</li>
            <li>Financial loss or indirect damages arising from use of the platform</li>
          </ul>
          <p>Use is at your own risk.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            8. Modifications to Terms
          </h3>
          <p>We may revise these Terms at any time. Material changes will be communicated via the platform or email. Your continued use after such changes constitutes acceptance.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            9. Governing Law
          </h3>
          <p>These Terms, and any additional terms, will be governed by and construed in accordance with the laws of the Province of Ontario, Canada, without regard to its conflict of laws principles.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            10. Dispute Resolution
          </h3>
          <p>Before initiating legal action, parties shall attempt informal resolution. If unresolved, the dispute shall be submitted to the courts of Ontario unless otherwise agreed in writing.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            11. Indemnity
          </h3>
          <p>You agree to indemnify, defend, and hold ChessThread harmless from any claims, damages, or liabilities arising from your content, your use of the service, or your violation of these Terms.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            12. User-Generated Content Disclaimer
          </h3>
          <p>ChessThread is not responsible for user-submitted content. We do not monitor all content and cannot guarantee its accuracy or appropriateness. Users post and view content at their own risk.</p>
          <p>Links to third-party sites are provided for convenience only. We are not responsible for their content or practices. We may remove content or restrict users at our discretion.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            13. Intellectual Property Rights
          </h3>
          <p>You retain ownership of the content you create. By submitting content to the platform, you grant ChessThread a non-exclusive, royalty-free, perpetual license to:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '15px' }}>
            <li>Display, host, and distribute your content within the platform</li>
            <li>Promote your content on external media or services</li>
          </ul>
          <p>You may request content removal at any time by contacting info@chessthread.com. We will comply where technically feasible and lawful.</p>
          <p>All site infrastructure, branding, design, and software are the property of ChessThread. Users may not copy, reverse-engineer, or commercially exploit the platform without written consent.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            14. Contact Information
          </h3>
          <p>Questions or requests regarding these Terms should be sent to:</p>
          <p style={{ fontWeight: 'bold' }}>Email: info@chessthread.com</p>
          <p style={{ marginTop: '20px', fontStyle: 'italic' }}>
            Use of ChessThread constitutes binding acceptance of these Terms in full. If you do not agree to these Terms, you must cease use of the platform immediately.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsMobile;